// Copyright 2021 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React, {Component} from "react";
import "./App.less";
import {Helmet} from "react-helmet";
import * as Setting from "./conf/Setting";
import {DownOutlined, LogoutOutlined, SettingOutlined} from "@ant-design/icons";
import {Avatar, BackTop, Button, Card, Dropdown, Layout, Menu, Result} from "antd";
import {Link, Redirect, Route, Switch, withRouter} from "react-router-dom";
// import OrganizationListPage from "./OrganizationListPage";
// import OrganizationEditPage from "./OrganizationEditPage";
import UserEditPage from "./pages/user/UserEditPage";
import RoleListPage from "./pages/role/RoleListPage";
import RoleEditPage from "./pages/role/RoleEditPage";
// import PermissionListPage from "./PermissionListPage";
// import PermissionEditPage from "./PermissionEditPage";
import ProviderListPage from "./pages/provider/ProviderListPage";
import ProviderEditPage from "./pages/provider/ProviderEditPage";
import ApplicationListPage from "./pages/application/ApplicationListPage";
import ApplicationEditPage from "./pages/application/ApplicationEditPage";
// import ResourceListPage from "./ResourceListPage";
import LdapEditPage from "./pages/ldap/LdapEditPage";
import LdapSyncPage from "./pages/ldap/LdapSyncPage";
// import TokenListPage from "./TokenListPage";
// import TokenEditPage from "./TokenEditPage";
import RecordListPage from "./pages/record/RecordListPage";
// import WebhookListPage from "./WebhookListPage";
// import WebhookEditPage from "./WebhookEditPage";
// import SyncerListPage from "./pages/syncer/SyncerListPage";
// import SyncerEditPage from "./pages/syncer/SyncerEditPage";
import SyncerManagement from "./pages/syncer/SyncerManagement";
import UpstreamSyncerEditPage from "./pages/syncer/UpstreamSyncerEditPage";
import DownstreamSyncerEditPage from "./pages/syncer/DownstreamSyncerEditPage";
import SyncerOrderEditPage from "./pages/syncer/SyncerOrderEditPage";
// import CertListPage from "./CertListPage";
// import CertEditPage from "./CertEditPage";
// import ProductListPage from "./ProductListPage";
// import ProductEditPage from "./ProductEditPage";
// import ProductBuyPage from "./ProductBuyPage";
// import PaymentListPage from "./PaymentListPage";
// import PaymentEditPage from "./PaymentEditPage";
// import PaymentResultPage from "./PaymentResultPage";
import AccountPage from "./pages/user/AccountPage";
import HomePage from "./pages/home/HomePage";
import CustomGithubCorner from "./components/common/CustomGithubCorner";
import * as Conf from "./conf/Conf";

import * as Auth from "./conf/Auth";
import SignupPage from "./pages/auth/SignupPage";
import ResultPage from "./pages/auth/ResultPage";
import LoginPage from "./pages/auth/LoginPage";
import SelfLoginPage from "./pages/auth/SelfLoginPage";
import SelfForgetPage from "./pages/auth/SelfForgetPage";
import ForgetPage from "./pages/auth/ForgetPage";
import * as AuthBackend from "./services/AuthBackend";
import AuthCallback from "./pages/auth/AuthCallback";
import SelectLanguageBox from "./components/common/SelectLanguageBox";
import i18next from "i18next";
import PromptPage from "./pages/prompt/PromptPage";
import OdicDiscoveryPage from "./pages/odic/OidcDiscoveryPage";
import SamlCallback from "./pages/auth/SamlCallback";
import CasLogout from "./pages/auth/CasLogout";
// import ModelListPage from "./ModelListPage";
// import ModelEditPage from "./ModelEditPage";
// import SystemInfo from "./SystemInfo";
// import AdapterListPage from "./AdapterListPage";
// import AdapterEditPage from "./AdapterEditPage";
import UserManagementPage from "./pages/user/UserManagementPage";
import GlobalContext from "./context/GlobalContext";
import LogoutResultPage from "./pages/auth/LogoutResultPage";
import LogoutPage from "./pages/auth/LogoutPage";
import AccountActivatePage from "./pages/auth/AccountActivatePage";
import SelfAccountActivatePage from "./pages/auth/SelfAccountActivatePage";
import PasswordRemindPage from "./pages/password/PasswordRemindPage";
// import * as PasswordPolicyBackend from "./services/PasswordPolicyBackend";
import SystemSetting from "./pages/system/SystemSetting";

const {Header} = Layout;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classes: props,
      selectedMenuKey: 0,
      account: undefined,
      uri: null,
      passwordCheckMsg: "",  // 密码修改提醒的提示语
      skipChangePassword: false,  // 强制密码修改页面是否显示下次修改
    };

    Setting.initServerUrl();
    Auth.initAuthWithConfig({
      serverUrl: Setting.ServerUrl,
      appName: Setting.AdminApplication, // the application name of Casdoor itself, do not change it
    });
  }

  componentDidMount() {
    this.updateMenuKey();
    this.getAccount();
  }

  componentDidUpdate() {
    // eslint-disable-next-line no-restricted-globals
    const uri = location.pathname;
    if (this.state.uri !== uri) {
      this.updateMenuKey();
    }
  }

  updateMenuKey() {
    // eslint-disable-next-line no-restricted-globals
    const uri = location.pathname;
    this.setState({
      uri: uri,
    });
    if (uri === "/") {
      this.setState({selectedMenuKey: "/"});
    } else if (uri.includes("/organizations")) {
      this.setState({selectedMenuKey: "/organizations"});
    } else if (uri.includes("/users")) {
      this.setState({selectedMenuKey: "/users"});
    } else if (uri.includes("/roles")) {
      this.setState({selectedMenuKey: "/roles"});
    } else if (uri.includes("/permissions")) {
      this.setState({selectedMenuKey: "/permissions"});
    } else if (uri.includes("/models")) {
      this.setState({selectedMenuKey: "/models"});
    } else if (uri.includes("/adapters")) {
      this.setState({selectedMenuKey: "/adapters"});
    } else if (uri.includes("/providers")) {
      this.setState({selectedMenuKey: "/providers"});
    } else if (uri.includes("/applications")) {
      this.setState({selectedMenuKey: "/applications"});
    } else if (uri.includes("/resources")) {
      this.setState({selectedMenuKey: "/resources"});
    } else if (uri.includes("/tokens")) {
      this.setState({selectedMenuKey: "/tokens"});
    } else if (uri.includes("/records")) {
      this.setState({selectedMenuKey: "/records"});
    } else if (uri.includes("/webhooks")) {
      this.setState({selectedMenuKey: "/webhooks"});
    } else if (uri.includes("/syncers")) {
      this.setState({selectedMenuKey: "/syncers"});
    } else if (uri.includes("/certs")) {
      this.setState({selectedMenuKey: "/certs"});
    } else if (uri.includes("/products")) {
      this.setState({selectedMenuKey: "/products"});
    } else if (uri.includes("/payments")) {
      this.setState({selectedMenuKey: "/payments"});
    } else if (uri.includes("/signup")) {
      this.setState({selectedMenuKey: "/signup"});
    } else if (uri.includes("/login")) {
      this.setState({selectedMenuKey: "/login"});
    } else if (uri.includes("/result")) {
      this.setState({selectedMenuKey: "/result"});
    } else if (uri.includes("/sysinfo")) {
      this.setState({selectedMenuKey: "/sysinfo"});
    } else if (uri.includes("/syssetting")) {
      this.setState({selectedMenuKey: "/syssetting"});
    } else {
      this.setState({selectedMenuKey: -1});
    }
  }

  getAccessTokenParam(params) {
    // "/page?access_token=123"
    const accessToken = params.get("access_token");
    return accessToken === null ? "" : `?accessToken=${accessToken}`;
  }

  getCredentialParams(params) {
    // "/page?username=abc&password=123"
    if (params.get("username") === null || params.get("password") === null) {
      return "";
    }
    return `?username=${params.get("username")}&password=${params.get("password")}`;
  }

  getUrlWithoutQuery() {
    return window.location.toString().replace(window.location.search, "");
  }

  getLanguageParam(params) {
    // "/page?language=en"
    const language = params.get("language");
    if (language !== null) {
      Setting.setLanguage(language);
      return `language=${language}`;
    }
    return "";
  }

  setLanguage(account) {
    const language = account?.language;
    if (language !== "" && language !== i18next.language) {
      Setting.setLanguage(language);
    }
  }

  getAccount() {
    const params = new URLSearchParams(this.props.location.search);

    let query = this.getAccessTokenParam(params);
    if (query === "") {
      query = this.getCredentialParams(params);
    }

    const query2 = this.getLanguageParam(params);
    if (query2 !== "") {
      const url = window.location.toString().replace(new RegExp(`[?&]${query2}`), "");
      window.history.replaceState({}, document.title, url);
    }

    if (query !== "") {
      window.history.replaceState({}, document.title, this.getUrlWithoutQuery());
    }

    const ths = this;
    AuthBackend.getAccount(query)
      .then((res) => {
        let account = null;
        if (res.status === "ok") {
          account = res.data;
          account.organization = res.data2;

          ths.setLanguage(account);
        }
        ths.setState({
          account: account,
        });
      });
  }

  logout() {
    this.setState({
      expired: false,
      submitted: false,
    });

    const params = new URLSearchParams(this.props.location.search);
    const redirect = params.get("redirect_uri");
    AuthBackend.logout(redirect)
      .then((res) => {
        if (res.status === "ok") {
          const owner = this.state.account.owner;

          this.setState({
            account: null,
          });

          Setting.clearSession();
          Setting.showMessage("success", i18next.t("login:Logged out successfully"));
          const redirectUri = res.data2;
          if (redirectUri !== null && redirectUri !== undefined && redirectUri !== "") {
            Setting.goToLink(redirectUri);
          } else if (!Setting.isAdminOrganization(owner)) {
            // Setting.goToLink(`${window.location.origin}/login/${owner}`);
            Setting.goToLink(`${window.location.origin}/logout/result`);
          } else {
            Setting.goToLinkSoft(this, "/");
          }
        } else {
          Setting.showMessage("error", `${i18next.t("login:Failed to log out")}: ${res.msg}`);
        }
      });
  }

  onUpdateAccount(account) {
    this.setState({
      account: account,
    });
  }

  handleRightDropdownClick(e) {
    if (e.key === "/account") {
      this.props.history.push("/account");
    } else if (e.key === "/logout") {
      this.logout();
    }
  }

  renderAvatar() {
    if (this.state.account.avatar === "") {
      return (
        // <Avatar style={{backgroundColor: Setting.getAvatarColor(this.state.account.name), verticalAlign: "middle"}} size="large">
        //   {Setting.getShortName(this.state.account.name)}
        // </Avatar>
        <Avatar src={require("./assets/images/default_avatar.png")} style={{verticalAlign: "middle"}} size="large">
          {Setting.getShortName(this.state.account.name)}
        </Avatar>
      );
    } else {
      return (
        <Avatar src={this.state.account.avatar} style={{verticalAlign: "middle"}} size="large">
          {Setting.getShortName(this.state.account.name)}
        </Avatar>
      );
    }
  }

  renderRightDropdown(isWhiteStyle) {
    const menu = (
      <Menu onClick={this.handleRightDropdownClick.bind(this)}>
        <Menu.Item key="/account">
          <SettingOutlined />
          &nbsp;
          {i18next.t("account:My Account")}
        </Menu.Item>
        <Menu.Item key="/logout">
          <LogoutOutlined />
          &nbsp;
          {i18next.t("account:Logout")}
        </Menu.Item>
      </Menu>
    );

    return (
      <Dropdown key="/rightDropDown" overlay={menu} className={isWhiteStyle ? "rightDropDown-white" : "rightDropDown"}>
        <div className="ant-dropdown-link" style={{float: "right", cursor: "pointer"}}>
          &nbsp;
          &nbsp;
          {
            this.renderAvatar()
          }
          &nbsp;
          &nbsp;
          {Setting.isMobile() ? null : Setting.getShortText(this.state.account.displayName, 7)} &nbsp; <DownOutlined />
          &nbsp;
          &nbsp;
          &nbsp;
        </div>
      </Dropdown>
    );
  }

  renderAccount(isWhiteStyle) {
    const res = [];

    if (this.state.account === undefined) {
      return null;
    } else if (this.state.account === null) {
      // res.push(
      //   <Menu.Item key="/signup" style={{float: 'right', marginRight: '20px'}}>
      //     <Link to="/signup">
      //       {i18next.t("account:Sign Up")}
      //     </Link>
      //   </Menu.Item>
      // );
      // res.push(
      //   <Menu.Item key="/login" style={{float: 'right'}}>
      //     <Link to="/login">
      //       {i18next.t("account:Login")}
      //     </Link>
      //   </Menu.Item>
      // );
    } else {
      res.push(this.renderRightDropdown(isWhiteStyle));
    }

    return res;
  }

  renderMenu() {
    const res = [];

    if (this.state.account === null || this.state.account === undefined) {
      return [];
    }

    res.push(
      <Menu.Item key="/">
        <Link to="/">
          {i18next.t("general:Home")}
        </Link>
      </Menu.Item>
    );

    if (Setting.isAdminUser(this.state.account)) {
      // res.push(
      //   <Menu.Item key="/organizations">
      //     <Link to="/organizations">
      //       {i18next.t("general:Organizations")}
      //     </Link>
      //   </Menu.Item>
      // );
      res.push(
        <Menu.Item key="/users">
          <Link to="/users">
            {i18next.t("general:User Management")}
          </Link>
        </Menu.Item>
      );
      res.push(
        <Menu.Item key="/roles">
          <Link to="/roles">
            {i18next.t("general:Roles Management")}
          </Link>
        </Menu.Item>
      );
      // res.push(
      //   <Menu.Item key="/permissions">
      //     <Link to="/permissions">
      //       {i18next.t("general:Permissions Management")}
      //     </Link>
      //   </Menu.Item>
      // );
    }

    if (Setting.isAdminUser(this.state.account)) {
      // res.push(
      //   <Menu.Item key="/models">
      //     <Link to="/models">
      //       {i18next.t("general:Models")}
      //     </Link>
      //   </Menu.Item>
      // );
      // res.push(
      //   <Menu.Item key="/adapters">
      //     <Link to="/adapters">
      //       {i18next.t("general:Adapters")}
      //     </Link>
      //   </Menu.Item>
      // );
      res.push(
        <Menu.Item key="/providers">
          <Link to="/providers">
            {i18next.t("general:Providers")}
          </Link>
        </Menu.Item>
      );
      res.push(
        <Menu.Item key="/applications">
          <Link to="/applications">
            {i18next.t("general:Applications Management")}
          </Link>
        </Menu.Item>
      );
    }

    if (Setting.isLocalAdminUser(this.state.account)) {
      // res.push(
      //   <Menu.Item key="/resources">
      //     <Link to="/resources">
      //       {i18next.t("general:Resources")}
      //     </Link>
      //   </Menu.Item>
      // );
      res.push(
        <Menu.Item key="/records">
          <Link to="/records">
            {i18next.t("general:Records")}
          </Link>
        </Menu.Item>
      );
    }

    if (Setting.isAdminUser(this.state.account)) {
      // res.push(
      //   <Menu.Item key="/tokens">
      //     <Link to="/tokens">
      //       {i18next.t("general:Tokens")}
      //     </Link>
      //   </Menu.Item>
      // );
      // res.push(
      //   <Menu.Item key="/webhooks">
      //     <Link to="/webhooks">
      //       {i18next.t("general:Webhooks")}
      //     </Link>
      //   </Menu.Item>
      // );
      res.push(
        <Menu.Item key="/syncers">
          <Link to="/syncers">
            {i18next.t("general:Syncers")}
          </Link>
        </Menu.Item>
      );
      res.push(
        <Menu.Item key="/syssetting">
          <Link to="/syssetting">
            {i18next.t("general:SysSetting")}
          </Link>
        </Menu.Item>
      );
      // res.push(
      //   <Menu.Item key="/certs">
      //     <Link to="/certs">
      //       {i18next.t("general:Certs")}
      //     </Link>
      //   </Menu.Item>
      // );

      if (Conf.EnableExtraPages) {
        // res.push(
        //   <Menu.Item key="/products">
        //     <Link to="/products">
        //       {i18next.t("general:Products")}
        //     </Link>
        //   </Menu.Item>
        // );
        // res.push(
        //   <Menu.Item key="/payments">
        //     <Link to="/payments">
        //       {i18next.t("general:Payments")}
        //     </Link>
        //   </Menu.Item>
        // );
        // res.push(
        //   <Menu.Item key="/sysinfo">
        //     <Link to="/sysinfo">
        //       {i18next.t("general:SysInfo")}
        //     </Link>
        //   </Menu.Item>
        // );
      }
      // res.push(
      //   <Menu.Item key="/swagger">
      //     <a target="_blank" rel="noreferrer" href={Setting.isLocalhost() ? `${Setting.ServerUrl}/swagger` : "/swagger"}>
      //       {i18next.t("general:Swagger")}
      //     </a>
      //   </Menu.Item>
      // );
    }

    return res;
  }

  renderHomeIfLoggedIn(component) {
    if (this.state.account !== null && this.state.account !== undefined && this.state.account.isActive) {
      return <Redirect to="/" />;
    } else {
      return component;
    }
  }

  renderLoginIfNotLoggedIn(component) {
    if (this.state.account === null) {
      sessionStorage.setItem("from", window.location.pathname);
      return <Redirect to="/login" />;
    } else if (this.state.account === undefined) {
      return null;
    } else {
      return component;
    }
  }

  isStartPages() {
    return window.location.pathname.startsWith("/login") ||
      window.location.pathname.startsWith("/signup") ||
      window.location.pathname === "/";
  }

  renderRouter() {
    return (
      <div style={{height: "100%"}}>
        <Switch>
          <Route exact path="/result" render={(props) => this.renderHomeIfLoggedIn(<ResultPage {...props} />)} />
          <Route exact path="/result/:applicationId" render={(props) => this.renderHomeIfLoggedIn(<ResultPage {...props} />)} />
          <Route exact path="/" render={(props) => this.renderLoginIfNotLoggedIn(<HomePage account={this.state.account} {...props} />)} />
          <Route exact path="/account" render={(props) => this.renderLoginIfNotLoggedIn(<AccountPage account={this.state.account} {...props} />)} />
          {/* <Route exact path="/organizations" render={(props) => this.renderLoginIfNotLoggedIn(<OrganizationListPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/organizations/:organizationId" render={(props) => this.renderLoginIfNotLoggedIn(<OrganizationEditPage account={this.state.account} {...props} />)} /> */}
          <Route exact path="/organizations/:organizationId/users" render={(props) => this.renderLoginIfNotLoggedIn(<UserManagementPage account={this.state.account} {...props} />)} />
          <Route exact path="/users" render={(props) => this.renderLoginIfNotLoggedIn(<UserManagementPage account={this.state.account} {...props} />)} />
          <Route exact path="/users/:organizationId/:userName" render={(props) => this.renderLoginIfNotLoggedIn(<UserEditPage account={this.state.account} {...props} />)} />
          <Route exact path="/roles" render={(props) => this.renderLoginIfNotLoggedIn(<RoleListPage account={this.state.account} {...props} />)} />
          <Route exact path="/roles/addStatic" render={(props) => this.renderLoginIfNotLoggedIn(<RoleEditPage account={this.state.account} mode="add" isStaticMode={true} {...props} />)} />
          <Route exact path="/roles/addDynamic" render={(props) => this.renderLoginIfNotLoggedIn(<RoleEditPage account={this.state.account} mode="add" isStaticMode={false} {...props} />)} />
          <Route exact path="/roles/:owner/:roleId" render={(props) => this.renderLoginIfNotLoggedIn(<RoleEditPage account={this.state.account} mode="edit" {...props} />)} />
          {/* <Route exact path="/permissions" render={(props) => this.renderLoginIfNotLoggedIn(<PermissionListPage account={this.state.account} {...props} />)} />
          <Route exact path="/permissions/:organizationId/:permissionName" render={(props) => this.renderLoginIfNotLoggedIn(<PermissionEditPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/models" render={(props) => this.renderLoginIfNotLoggedIn(<ModelListPage account={this.state.account} {...props} />)} />
          <Route exact path="/models/:organizationId/:modelName" render={(props) => this.renderLoginIfNotLoggedIn(<ModelEditPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/adapters" render={(props) => this.renderLoginIfNotLoggedIn(<AdapterListPage account={this.state.account} {...props} />)} />
          <Route exact path="/adapters/:organizationId/:adapterName" render={(props) => this.renderLoginIfNotLoggedIn(<AdapterEditPage account={this.state.account} {...props} />)} /> */}
          <Route exact path="/providers" render={(props) => this.renderLoginIfNotLoggedIn(<ProviderListPage account={this.state.account} {...props} />)} />
          <Route exact path="/providers/:providerId" render={(props) => this.renderLoginIfNotLoggedIn(<ProviderEditPage account={this.state.account} {...props} />)} />
          <Route exact path="/applications" render={(props) => this.renderLoginIfNotLoggedIn(<ApplicationListPage account={this.state.account} {...props} />)} />
          <Route exact path="/applications/:applicationId" render={(props) => this.renderLoginIfNotLoggedIn(<ApplicationEditPage account={this.state.account} {...props} />)} />
          {/* <Route exact path="/resources" render={(props) => this.renderLoginIfNotLoggedIn(<ResourceListPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/resources/:resourceName" render={(props) => this.renderLoginIfNotLoggedIn(<ResourceEditPage account={this.state.account} {...props} />)}/>*/}
          <Route exact path="/ldap/:ldapId" render={(props) => this.renderLoginIfNotLoggedIn(<LdapEditPage account={this.state.account} {...props} />)} />
          <Route exact path="/ldap/sync/:ldapId" render={(props) => this.renderLoginIfNotLoggedIn(<LdapSyncPage account={this.state.account} {...props} />)} />
          {/* <Route exact path="/tokens" render={(props) => this.renderLoginIfNotLoggedIn(<TokenListPage account={this.state.account} {...props} />)} />
          <Route exact path="/tokens/:tokenName" render={(props) => this.renderLoginIfNotLoggedIn(<TokenEditPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/webhooks" render={(props) => this.renderLoginIfNotLoggedIn(<WebhookListPage account={this.state.account} {...props} />)} />
          <Route exact path="/webhooks/:webhookName" render={(props) => this.renderLoginIfNotLoggedIn(<WebhookEditPage account={this.state.account} {...props} />)} /> */}
          <Route exact path="/syncers" render={(props) => this.renderLoginIfNotLoggedIn(<SyncerManagement account={this.state.account} {...props} />)} />
          <Route exact path="/syncers/upstream/add" render={(props) => this.renderLoginIfNotLoggedIn(<UpstreamSyncerEditPage account={this.state.account} mode="add" {...props} />)} />
          <Route exact path="/syncers/upstream/:owner/:syncerId" render={(props) => this.renderLoginIfNotLoggedIn(<UpstreamSyncerEditPage account={this.state.account} mode="edit" {...props} />)} />
          <Route exact path="/syncers/downstream/add" render={(props) => this.renderLoginIfNotLoggedIn(<DownstreamSyncerEditPage account={this.state.account} mode="add" {...props} />)} />
          <Route exact path="/syncers/downstream/:owner/:syncerId" render={(props) => this.renderLoginIfNotLoggedIn(<DownstreamSyncerEditPage account={this.state.account} mode="edit" {...props} />)} />
          <Route exact path="/syncers/upstream/order" render={(props) => this.renderLoginIfNotLoggedIn(<SyncerOrderEditPage account={this.state.account} mode="order" {...props} />)} />
          {/* <Route exact path="/certs" render={(props) => this.renderLoginIfNotLoggedIn(<CertListPage account={this.state.account} {...props} />)} />
          <Route exact path="/certs/:certName" render={(props) => this.renderLoginIfNotLoggedIn(<CertEditPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/products" render={(props) => this.renderLoginIfNotLoggedIn(<ProductListPage account={this.state.account} {...props} />)} />
          <Route exact path="/products/:productName" render={(props) => this.renderLoginIfNotLoggedIn(<ProductEditPage account={this.state.account} {...props} />)} />
          <Route exact path="/products/:productName/buy" render={(props) => this.renderLoginIfNotLoggedIn(<ProductBuyPage account={this.state.account} {...props} />)} /> */}
          {/* <Route exact path="/payments" render={(props) => this.renderLoginIfNotLoggedIn(<PaymentListPage account={this.state.account} {...props} />)} />
          <Route exact path="/payments/:paymentName" render={(props) => this.renderLoginIfNotLoggedIn(<PaymentEditPage account={this.state.account} {...props} />)} />
          <Route exact path="/payments/:paymentName/result" render={(props) => this.renderLoginIfNotLoggedIn(<PaymentResultPage account={this.state.account} {...props} />)} /> */}
          <Route exact path="/records" render={(props) => this.renderLoginIfNotLoggedIn(<RecordListPage account={this.state.account} {...props} />)} />
          <Route exact path="/.well-known/openid-configuration" render={(props) => <OdicDiscoveryPage />} />
          <Route path="/syssetting" render={(props) => this.renderLoginIfNotLoggedIn(<SystemSetting account={this.state.account} {...props} />)} />
          {/* <Route exact path="/sysinfo" render={(props) => this.renderLoginIfNotLoggedIn(<SystemInfo account={this.state.account} {...props} />)} /> */}
          <Route path="" render={() => <Result status="404" title="404 NOT FOUND" subTitle={i18next.t("general:Sorry, the page you visited does not exist.")}
            extra={<a href="/"><Button type="primary">{i18next.t("general:Back Home")}</Button></a>} />} />
        </Switch>
      </div>
    );
  }

  renderLogo(application) {
    const styleDisplayname = {
      color: "#fff",
      marginLeft: 36,
      fontSize: 24,
    };

    return (
      <div style={{display: "flex", flexDirection: "row", alignItems: "center", width: 200, float: "left"}}>
        {/* {
          application.systemLogo === "" ?
            <img
              src={application.logo === "" ? require("../../assets/images/default_icon_white.png") : application.logo}
              alt={application.displayName}
              style={{width: 48, height: 48}}
            />
            :
            <Col>
              {
                <li className="icon-container" style={{width: 48, height: 48}}
                >
                  <span className={["app-icon", application.sysLogoBg].join(" ")} style={{width: 40, height: 40, fontSize: isSmallScreen ? 20 : 32}}></span>
                </li>
              }
            </Col>
        } */}
        <p style={styleDisplayname}>{i18next.t("统一身份认证")}</p>
      </div>
    );
  }

  renderGateHeader() {
    return <Header style={{padding: "0"}}><div style={{
      background: `url(${
        require("./assets/images/nav_header.png")
      }) center top no-repeat`,
      width: "100%",
      height: "100%",
      color: "#fff",
      // display: "flex",
      // justifyContent: "space-between",
      backgroundSize: "cover"}}
    >
      {/* <Menu
        theme="light"
        mode={(Setting.isMobile() && this.isStartPages()) ? "inline" : "horizontal"}
        selectedKeys={[`${this.state.selectedMenuKey}`]}
        style={{background: "transparent", lineHeight: "64px", position: "absolute", left: "0px", right: "230px", color: "#fff"}}
      >
        {
          this.renderMenu()
        }
      </Menu> */}
      {this.renderLogo(this.state.account)}
      {
        this.renderAccount(true)
      }
      <SelectLanguageBox style={{color: "#fff"}} isWhite={true} />
    </div></Header>;
  }

  renderHeader() {
    return <Header style={{padding: "0", marginBottom: "3px"}}>
      {/* {
      Setting.isMobile() ? null : (
        <Link to={"/"}>
          <div className="logo" />
        </Link>
      )
    } */}
      <div>
        <Menu
        // theme="dark"
          mode={(Setting.isMobile() && this.isStartPages()) ? "inline" : "horizontal"}
          selectedKeys={[`${this.state.selectedMenuKey}`]}
          style={{lineHeight: "64px", position: "absolute", left: "0px", right: "230px"}}
        >
          {
            this.renderMenu()
          }
        </Menu>
        {
          this.renderAccount()
        }
        <SelectLanguageBox />
      </div>
    </Header>;
  }

  renderContent() {
    if (window.location.pathname.startsWith("/password/remind")) {
      return (
        <div style={{display: "flex", flexDirection: "column", height: "100vh"}}>
          <div id="login-content-wrap" style={{flexDirection: "column"}}>
            <Switch>
              <Route exact path="/password/remind/:organizationId" render={(props) => this.renderLoginIfNotLoggedIn(<PasswordRemindPage account={this.state.account} {...props} />)} />
              <Route exact path="/password/remind/:organizationId/*" render={(props) => this.renderLoginIfNotLoggedIn(<PasswordRemindPage account={this.state.account} {...props} />)} />
              <Route path="" render={() => <Result status="404" title="404 NOT FOUND" subTitle={i18next.t("general:Sorry, the page you visited does not exist.")}
                extra={<a href="/"><Button type="primary">{i18next.t("general:Back Home")}</Button></a>} />} />
            </Switch>
          </div>
        </div>
      );
    }

    if (!Setting.isMobile()) {
      return (
        <div style={{display: "flex", flex: "auto", width: "100%", flexDirection: "column"}}>
          <Layout style={{display: "flex", alignItems: "stretch"}}>
            {
              this.state.selectedMenuKey === "/" && this.state.account && !Setting.isAdminUser(this.state.account) ?
                this.renderGateHeader()
                :
                this.renderHeader()
            }
            <Layout style={{backgroundColor: "#f5f5f5", alignItems: "stretch"}}>
              {
                this.state.selectedMenuKey === "syssetting" || this.state.selectedMenuKey === "/" ?
                  this.renderRouter()
                  :
                  <Card className="content-warp-card">
                    {
                      this.renderRouter()
                    }
                  </Card>
              }
            </Layout>
          </Layout>
        </div>
      );
    } else {
      return (
        <div>
          {Setting.getENVIR() !== "wxh5" && <Header style={{padding: "0", marginBottom: "3px", display: "flex", justifyContent: "space-between"}}>
            {
              Setting.isMobile() ? null : (
                <Link to={"/"}>
                  <div className="logo" />
                </Link>
              )
            }
            <Menu
            // theme="dark"
              mode={(Setting.isMobile() && this.isStartPages()) ? "inline" : "horizontal"}
              selectedKeys={[`${this.state.selectedMenuKey}`]}
              style={{lineHeight: "64px", flex: 1}}
            >
              {
                this.renderMenu()
              }

            </Menu>
            <div style = {{float: "right"}}>
              {
                this.renderAccount()
              }
              <SelectLanguageBox />
            </div>
          </Header>}
          {
            this.renderRouter()
          }
        </div>
      );
    }
  }

  renderFooter() {
    // How to keep your footer where it belongs ?
    // https://www.freecodecamp.org/neyarnws/how-to-keep-your-footer-where-it-belongs-59c6aa05c59c/

    // return (
    //   <>
    //     {!this.state.account ? null : <div style={{display: "none"}} id="CasdoorApplicationName" value={this.state.account.signupApplication} />}
    //     <Footer id="footer" style={
    //       {
    //         borderTop: "1px solid #e8e8e8",
    //         backgroundColor: "white",
    //         textAlign: "center",
    //       }
    //     }>
    //       Powered by <a target="_blank" href="https://casdoor.org" rel="noreferrer"><img style={{paddingBottom: "3px"}} height={"20px"} alt={"Casdoor"} src={`${Setting.StaticBaseUrl}/img/casdoor-logo_1185x256.png`} /></a>
    //     </Footer>
    //   </>
    // );
  }

  isDoorPages() {
    return window.location.pathname.startsWith("/signup") ||
      window.location.pathname.startsWith("/login") ||
      window.location.pathname.startsWith("/callback") ||
      window.location.pathname.startsWith("/prompt") ||
      window.location.pathname.startsWith("/forget") ||
      window.location.pathname.startsWith("/cas") ||
			window.location.pathname.startsWith("/logout") ||
      window.location.pathname.startsWith("/activate") ||
      window.location.pathname.startsWith("/gate");
  }

  renderPage() {
    if (this.isDoorPages()) {
      return (
        <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
          <div id="login-content-wrap b1" className="page-bg" style={{flexDirection: "column"}}>
            <Switch>
              <Route exact path="/signup" render={(props) => this.renderHomeIfLoggedIn(<SignupPage account={this.state.account} {...props} />)} />
              <Route exact path="/signup/:applicationId" render={(props) => this.renderHomeIfLoggedIn(<SignupPage account={this.state.account} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />)} />
              <Route exact path="/login" render={(props) => this.renderHomeIfLoggedIn(<SelfLoginPage account={this.state.account} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />)} />
              <Route exact path="/login/:owner" render={(props) => this.renderHomeIfLoggedIn(<SelfLoginPage account={this.state.account} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />)} />
              <Route exact path="/auto-signup/oauth/authorize" render={(props) => <LoginPage account={this.state.account} type={"code"} mode={"signup"} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />} />
              <Route exact path="/signup/oauth/authorize" render={(props) => <SignupPage account={this.state.account} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />} />
              <Route exact path="/login/oauth/authorize" render={(props) => <LoginPage account={this.state.account} type={"code"} mode={"signin"} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />} />
              <Route exact path="/login/saml/authorize/:owner/:applicationId" render={(props) => <LoginPage account={this.state.account} type={"saml"} mode={"signin"} {...props} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} />} />
              <Route exact path="/cas/:owner/:casApplicationName/logout" render={(props) => this.renderHomeIfLoggedIn(<CasLogout clearAccount={() => this.setState({account: null})} {...props} />)} />
              <Route exact path="/cas/:owner/:casApplicationName/login" render={(props) => {return (<LoginPage type={"cas"} mode={"signin"} account={this.state.account} {...props} />);}} />
              <Route exact path="/callback" component={AuthCallback} />
              <Route exact path="/callback/saml" component={SamlCallback} />
              <Route exact path="/forget/:applicationId/*" render={(props) => this.renderHomeIfLoggedIn(<ForgetPage {...props} />)} />
              <Route exact path="/forget/*" render={(props) => this.renderHomeIfLoggedIn(<SelfForgetPage {...props} />)} />
              <Route exact path="/activate/:applicationId/*" render={(props) => this.renderHomeIfLoggedIn(<AccountActivatePage account={this.state.account} {...props} />)} />
              <Route exact path="/activate/*" render={(props) => this.renderHomeIfLoggedIn(<SelfAccountActivatePage account={this.state.account} {...props} />)} />
              <Route exact path="/prompt" render={(props) => this.renderLoginIfNotLoggedIn(<PromptPage account={this.state.account} {...props} />)} />
              <Route exact path="/prompt/:applicationId" render={(props) => this.renderLoginIfNotLoggedIn(<PromptPage account={this.state.account} onUpdateAccount={(account) => {this.onUpdateAccount(account);}} {...props} />)} />
              {/* <Route exact path="/sysinfo" render={(props) => this.renderLoginIfNotLoggedIn(<SystemInfo {...props} />)} /> */}
              {/* <Route exact path="/remind/:organizationId" render={(props) => this.renderLoginIfNotLoggedIn(<PasswordRemindPage account={this.state.account} {...props} />)} /> */}
              <Route exact path="/logout" render={(props) => <LogoutPage {...props} />} />
              <Route exact path="/logout/result" render={() => this.renderHomeIfLoggedIn(<LogoutResultPage />)} />
              <Route path="" render={() => <Result status="404" title="404 NOT FOUND" subTitle={i18next.t("general:Sorry, the page you visited does not exist.")}
                extra={<a href="/"><Button type="primary">{i18next.t("general:Back Home")}</Button></a>} />} />
            </Switch>
          </div>
          {
            this.renderFooter()
          }
        </div>
      );
    }

    return (
      <div id="parent-area">
        <BackTop />
        <CustomGithubCorner />
        <div id="content-wrap" style={{flexDirection: "column"}}>
          {
            this.renderContent()
          }
        </div>
        {
          this.renderFooter()
        }
      </div>
    );
  }

  render() {
    if (this.state.account === undefined || this.state.account === null) {
      return (
        <React.Fragment>
          {/* <Helmet>
            <link rel="icon" href={require("./assets/images/default_icon.png")} />
          </Helmet> */}
          {
            this.renderPage()
          }
        </React.Fragment>
      );
    }

    const organization = this.state.account.organization;
    return (
      <GlobalContext.Provider value={{
        account: this.state.account,
        updateAccount: (account) => {
          this.setState(state => ({
            account: account,
          }));
        },
        passwordCheckMsg: this.state.passwordCheckMsg,
        updatePasswordCheckMsg: (msg) => {
          this.setState(state => ({
            passwordCheckMsg: msg,
          }));
        },
        updateSkipPasswordCheck: (skip) => {
          window.sessionStorage.setItem("__SKIP_PASSWORD_CHECK__", skip ? "1" : "0");
        },
        skipChangePassword: this.state.skipChangePassword,
        updateShipChangePassword: (show, callback) => {
          this.setState(state => ({
            skipChangePassword: show,
          }));
        },
      }}>
        <React.Fragment>
          <Helmet>
            <title>{organization.displayName}</title>
            <link rel="icon" href={organization.favicon} />
          </Helmet>
          {
            this.renderPage()
          }
        </React.Fragment>
      </GlobalContext.Provider>
    );
  }
}

export default withRouter(App);
